import MappingValueInput from "../MappingValueInput";
import { INTERCOM_TICKET_TYPE_ID, ClientMappingField, INTERCOM_ADMIN_ID, INTERCOM_REQUEST_TYPE } from "@avenueops/shared-types";
import UncontrolledInputSearchableSelect from "components/inputs/UncontrolledInputSearchableSelect";
import { trpc2 } from "utils/trpc";

interface Props {
  integrationId: string;
  fullFieldName: string;
  fieldValue: string;
  fieldError: any;
  onChange: any;
  isFirst: boolean;
  update: (_: ClientMappingField) => void;
  field: ClientMappingField;
  prefix: string;
}

export default function EnhancedIntercomFieldValueMappingInput({
  integrationId,
  fullFieldName,
  fieldValue,
  fieldError,
  onChange,
  isFirst,
  update,
  field,
  prefix,
}: Props) {
  const { data: intercomTicketTypes } = trpc2.v2.intercom.getTicketTypes.useQuery({ integrationId }, { enabled: fullFieldName === INTERCOM_TICKET_TYPE_ID });

  const { data: intercomAdmins } = trpc2.v2.intercom.getAdmins.useQuery({ integrationId }, { enabled: fullFieldName === INTERCOM_ADMIN_ID });

  return fullFieldName === INTERCOM_REQUEST_TYPE ? (
    <div>
      <UncontrolledInputSearchableSelect
        title={fullFieldName}
        disabled={false}
        options={[
          { value: "event", label: "Data Event" },
          { value: "ticket", label: "Ticket Creation" },
        ]}
        val={fieldValue}
        onChange={onChange}
        placeholder={"Users ..."}
        error={fieldError}
      />
    </div>
  ) : fullFieldName === INTERCOM_TICKET_TYPE_ID ? (
    <div>
      <UncontrolledInputSearchableSelect
        title={fullFieldName}
        disabled={false}
        options={intercomTicketTypes ?? []}
        val={fieldValue}
        onChange={onChange}
        placeholder={"Users ..."}
        error={fieldError}
      />
    </div>
  ) : fullFieldName === INTERCOM_ADMIN_ID ? (
    <div className="min-w-320 w-auto">
      <UncontrolledInputSearchableSelect
        title={fullFieldName}
        disabled={false}
        options={intercomAdmins ?? []}
        val={fieldValue}
        onChange={onChange}
        placeholder={"Users ..."}
        error={fieldError}
      />
    </div>
  ) : (
    <MappingValueInput update={update} item={field} isFirst={isFirst} prefix={prefix} />
  );
}
